<template>
    <div>
        <br>
        <h3>Company Information</h3>
        <hr>
        <vue-form :state="formstate">
            <div class="row">
                <div class="col">
                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.companyName)">
                        <label>Company Name</label>
                        <input type="text" name="companyName" class="form-control" required
                               v-model.lazy="state.registrantData.industryExtraData.companyName" tabindex="15">
                        <field-messages name="companyName" show="$touched || $submitted" class="form-control-feedback">
                            <div>Success!</div>
                            <div slot="required">This is a required field</div>
                        </field-messages>
                    </validate>
                </div>
            </div>
            <br>
        </vue-form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'Industry',
        data: function () {
            return {
                formstate: {},
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),

        },
        watch: {
            formstate: function (val) {
                this.state.formstate.industry = val;
            },
        },
        methods: {
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },
            onSubmit: function () {
                console.log(this.formstate.$valid)
            }
        },
    }
</script>

<style>
    .required-field > label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
</style>
